// src/components/TransactionCard.tsx
import React from 'react';
import { Card, Row, Col, Badge } from 'react-bootstrap';
import { DetailedTransaction } from '../interfaces/transaction-details.interface';
import { TransactionStatus } from '../../enum/transaction-status.enum';

interface TransactionCardProps {
  transaction: DetailedTransaction;
  onClick: () => void;
}

const TransactionCard: React.FC<TransactionCardProps> = ({ transaction, onClick }) => {
  const { status, detail, destinationAccount } = transaction;

  // Determine Badge color based on status
  const badgeVariant =
    status === TransactionStatus.Successful
      ? 'success'
      : status === TransactionStatus.Pending
        ? 'warning'
        : 'danger';

  // Convert date
  const formatDate = (dateString: string) => {
    const dateObj = new Date(dateString);
    return dateObj.toLocaleString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };

  // Mask Account Number (**** últimos 4)
  const maskAccountNumber = (number: string) => {
    return `**** **** **** ${number.slice(-4)}`;
  };

  return (
    <Card className="shadow-lg" onClick={onClick} style={{ cursor: 'pointer' }}>
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Transaction Details</h4>
        <Badge bg={badgeVariant}>{status}</Badge>
      </Card.Header>
      <Card.Body>
        {/* Transaction Info */}
        <Row className="mb-3">
          <Col xs={6} className="text-start"><strong>Transaction:</strong></Col>
          <Col xs={6} className="text-end">{transaction.transaction}</Col>
        </Row>

        <Row className="mb-3">
          <Col xs={6} className="text-start"><strong>Requested Amount:</strong></Col>
          <Col xs={6} className="text-end">{`${detail.requestedAmount.toFixed(2)}`}</Col>
        </Row>

        <Row className="mb-3">
          <Col xs={6} className="text-start"><strong>Date:</strong></Col>
          <Col xs={6} className="text-end">{formatDate(detail.date)}</Col>
        </Row>

        <hr />

        {/* Destination Account Info */}
        <Row className="mb-3">
          <Col xs={12} className="text-start">
            <h5>Destination Account</h5>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col xs={6} className="text-start"><strong>Bank Name:</strong></Col>
          <Col xs={6} className="text-end">{destinationAccount.bankAccountName}</Col>
        </Row>

        <Row className="mb-3">
          <Col xs={6} className="text-start"><strong>Account Number:</strong></Col>
          <Col xs={6} className="text-end">{maskAccountNumber(destinationAccount.bankAccountNumber)}</Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default TransactionCard;